import { render, staticRenderFns } from "./CustomerItem.vue?vue&type=template&id=6a180f7e&scoped=true&"
import script from "./CustomerItem.vue?vue&type=script&lang=js&"
export * from "./CustomerItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerItem.vue?vue&type=style&index=0&id=6a180f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a180f7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VIcon,VLayout,VSlideYTransition})
